import {
  GhanaCardVerificationRequestDto,
  QueryMerchantCategoriesDto,
  VerifyBankAccountDto,
  VerifyMerchantDetailsDto,
} from "../../../models/miscellaneous.dto";
import {
  AddProductToMerchantRequestCreateDto,
  OnboardMerchantDto,
  PaymentSetupDto,
  PaymentSetupPaginator,
  QueryDraftPaymentSetupDto,
  QueryMerchantRequestDto,
  QueryPaymentSetupDto,
  SearchMerchantRequestDto,
  UpdateOnboardedMerchantDto,
  UpdatePaymentSetupDto,
  UpdateProductToMerchantRequestCreateDto,
} from "../../../models/payment-setup.dto";
import { HttpClient } from "../requests";
import ENDPOINTS from "../endpoints";

export class Payment {
  listPaymentInstitutions = (query?: any) =>
    HttpClient.post<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.LIST_PAYMENT_INSTITUTIONS,
      query,
    );
  getTiers = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_TIERS);
  getAvailablePaymentDestinations = () =>
    HttpClient.get<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_AVAILABLE_PAYMENT_DESTINATIONS,
    );
  getMerchantCategories = (query?: QueryMerchantCategoriesDto) =>
    HttpClient.get<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_MERCHANT_CATEGORIES,
      query,
    );
  getProducts = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_PRODUCTS);
  getRegions = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_REGIONS);
  getTags = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_TAGS);
  getCompanyTypes = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_COMPANY_TYPES);
  getContactTypes = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_CONTACT_TYPES);
  getSourceMerchants = () =>
    HttpClient.get<any>(ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_SOURCE_MERCHANTS);
  getSourceMerchantProducts = (id: number) =>
    HttpClient.get<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_SOURCE_MERCHANT_PRODUCTS.replace(
        "{id}",
        String(id),
      ),
    );
  getSourceMerchantProduct = (merchantProductId: string) =>
    HttpClient.get<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.GET_SOURCE_MERCHANT_PRODUCT.replace(
        "{merchantProductId}",
        String(merchantProductId),
      ),
    );
  verifyGhanaCard = ({
    ghanaCardNumber,
    file,
  }: GhanaCardVerificationRequestDto) => {
    const formData = new FormData();
    formData.append("ghanaCardNumber", ghanaCardNumber);
    formData.append("file", file);
    return HttpClient.postFile<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.VERIFY_GHANA_CARD,
      formData,
    );
  };
  viewGhanaCardVerification = (requestId: string | number) =>
    HttpClient.get<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.VIEW_GHANA_CARD_VERIFICATION.replace(
        "{requestId}",
        String(requestId),
      ),
    );
  verifyMerchantDetails = (payload: VerifyMerchantDetailsDto) =>
    HttpClient.post<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.VERIFY_MERCHANT_DETAILS,
      payload,
    );
  verifyBankAccount = (payload: VerifyBankAccountDto) =>
    HttpClient.post<any>(
      ENDPOINTS.PAYMENTS.MISCELLANEOUS.VERIFY_BANK_ACCOUNT,
      payload,
    );

  onboardMerchants = (
    companyId: string | number,
    payload: OnboardMerchantDto,
  ) =>
    HttpClient.post<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.ONBOARD_MERCHANTS.replace(
        "{companyId}",
        String(companyId),
      ),
      payload,
    );
  addRequestSections = (id: string | number, payload: UpdatePaymentSetupDto) =>
    HttpClient.post<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.ADD_REQUEST_SECTIONS.replace(
        "{id}",
        String(id),
      ),
      payload,
    );
  addProductRequest = (
    id: string | number,
    payload: AddProductToMerchantRequestCreateDto,
  ) =>
    HttpClient.post<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.ADD_PRODUCT_REQUEST.replace(
        "{id}",
        String(id),
      ),
      payload,
    );
  submitUpdateOnboardedMerchantRequest = (
    id: string | number,
    payload: UpdateOnboardedMerchantDto,
  ) =>
    HttpClient.patch<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.SUBMIT_UPDATE_ONBOARDED_MERCHANT_REQUEST.replace(
        "{id}",
        String(id),
      ),
      payload,
    );
  updateSubmittedMerchantRequest = (
    id: string | number,
    payload: UpdateOnboardedMerchantDto,
  ) =>
    HttpClient.patch<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.UPDATE_SUBMITTED_MERCHANT_REQUEST.replace(
        "{id}",
        String(id),
      ),
      payload,
    );
  updateSubmittedProductRequest = (
    id: string | number,
    payload: UpdateProductToMerchantRequestCreateDto,
  ) =>
    HttpClient.patch<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.UPDATE_SUBMITTED_PRODUCT_REQUEST.replace(
        "{id}",
        String(id),
      ),
      payload,
    );
  draftMerchantRequest = (
    companyId: string | number,
    payload: UpdateOnboardedMerchantDto,
  ) =>
    HttpClient.post<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.DRAFT_MERCHANT_REQUEST.replace(
        "{companyId}",
        String(companyId),
      ),
      payload,
    );
  getDraftMerchantRequests = (
    companyId: string | number,
    query: QueryDraftPaymentSetupDto,
  ) =>
    HttpClient.get<PaymentSetupPaginator>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.GET_DRAFT_MERCHANT_REQUESTS.replace(
        "{companyId}",
        String(companyId),
      ),
      query,
    );
  updateDraftedMerchantRequest = (
    id: string | number,
    companyId: string | number,
    payload: UpdateOnboardedMerchantDto,
  ) =>
    HttpClient.patch<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.UPDATE_DRAFTED_MERCHANT_REQUEST.replace(
        "{id}",
        String(id),
      ).replace("{companyId}", String(companyId)),
      payload,
    );
  deleteDraftedMerchantRequest = (
    id: string | number,
    companyId: string | number,
  ) =>
    HttpClient.delete<void>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.DELETE_DRAFTED_MERCHANT_REQUEST.replace(
        "{id}",
        String(id),
      ).replace("{companyId}", String(companyId)),
    );
  finalizeMerchantRequestDraft = (
    id: string | number,
    companyId: string | number,
    payload: OnboardMerchantDto,
  ) =>
    HttpClient.post<PaymentSetupDto>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.FINALIZE_MERCHANT_REQUEST_DRAFT.replace(
        "{id}",
        String(id),
      ).replace("{companyId}", String(companyId)),
      payload,
    );
  getCompanyPaymentSetups = (
    companyId: string | number,
    query?: QueryPaymentSetupDto,
  ) =>
    HttpClient.get<PaymentSetupPaginator>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.GET_COMPANY_PAYMENT_SETUPS.replace(
        "{companyId}",
        String(companyId),
      ),
      query,
    );
  getMerchantRequestList = (query?: QueryMerchantRequestDto) =>
    HttpClient.get<PaymentSetupPaginator>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.GET_MERCHANT_REQUEST_LIST,
      query,
    );
  searchMerchantRequest = (query?: SearchMerchantRequestDto) =>
    HttpClient.get<PaymentSetupPaginator>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.SEARCH_MERCHANT_REQUEST,
      query,
    );
  getMerchantRequestIssues = (id: number) =>
    HttpClient.get<any>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.GET_MERCHANT_REQUEST_ISSUES.replace(
        "{id}",
        String(id),
      ),
    );
  getMerchantRequest = (id: number, query?: QueryMerchantRequestDto) =>
    HttpClient.get<{ data: PaymentSetupDto }>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.GET_MERCHANT_REQUEST.replace(
        "{id}",
        String(id),
      ),
      query,
    );
  validatePaymentAccount = (payload: any) =>
    HttpClient.post<any>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.VALIDATE_PAYMENT_ACCOUNT,
      payload,
    );
  getPaymentAccountName = (payload: any) =>
    HttpClient.post<any>(
      ENDPOINTS.PAYMENTS.PAYMENT_SETUP.GET_PAYMENT_ACCOUNT_NAME,
      payload,
    );
}
